<app-form-input 
[parentForm]="parentForm" 
[label]="step9.getspan8"
[type]="'radio'"
[disabled]="disabled"
     [rule]="'pattern_29'"
[value]="radioButtonValue"
[name]="radioButtonCtrlName"
[radios]="[
						{
                            value: region,
							label: step9.getregion
						},
                        {
                            value: departement,
							label: step9.getdepartement
						},
                        {
                            value: etat,
							label: step9.getetat
						},
                        {
                            value: debiteurEtranger,
							label: step9.getdebiteuretranger
						},
						{
                            value: debiteurPrivePersMorale,
							label: step9.getdebiteurprivepersmorale
						},
                        {
                            value: debiteurPrivePersPhysique,
							label: step9.getdebiteurprivepersphysique
						},
                        {
                            value: groupementCollectivites,
							label: step9.getgroupementcollectivites
						},
                        {
                            value: commune,
							label: step9.getcommune
						},
                        {
                            value: autresOrganismesPublics,
							label: step9.getautresorganismespublics
						},
                        {
                            value: etablissementsPublicsSante,
							label: step9.getetablissementspublicssante
						}
						
    ]"
>
</app-form-input>
